import React, { useEffect, useRef, useState } from "react"
import { Office, CircularGrid, ProjectIcon, ContactorIcon, LetterTypee, Employee, SearchSmall, SearchBig, Status } from "./AllSvg"
import axios from "axios"
import { BASE_URL } from "../config/axios"
import usePermission from "../config/permissions"
import { CSSForFilterDropdown, CSSForFilterDropdown10VW, CSSForMultiSelectOption, CSSForSelect, CSSForSelect10vWWidth, CSSForSelect15vWWidth, CSSForSelectModern, CSSForSelectSmallWidth, getCSSForFilterDropdown, sortProjects } from "./CustomFunctions"
import Select, { components } from "react-select";
import { Building, Building2, Calendar, CarFront, Check, ChevronDown, Clock, Search, SearchCheck, User, UserCog, X } from "lucide-react"
import "./SiteManagement/css/Filter.css";

const LetterStatus = ({ selectedLetterStatus, setLetterStatus }) => {
    return (
        <div title="Status Filter" className="field-cont-div">
            <CircularGrid />
            <select
                id="status"
                name="status"
                placeholder="Status"
                value={selectedLetterStatus}
                onChange={(e) => setLetterStatus(e.target.value)}
                className={`attendance-input-field width-10vw `}
            >



                <option value="null">Select a Status</option>
                <option value="pending">Pending</option>
                <option value="in-progress">InProgress</option>
                <option value="partially-close">Partially Close</option>
                <option value="close">Close</option>



            </select>
            <hr className="field-cont-hr" />
        </div>
    )
}




const LetterType = ({ setLetterType, lettertype, LetterTypeOptions, handleChange }) => {
    return (
        <>
            <div title="Letter Type" className="field-cont-div">
                <LetterTypee />
                {/* <select
                    onChange={(e) => setLetterType(e.target.value)}
                    value={lettertype}
                    style={{ cursor: 'pointer' }}
                    className="attendance-input-field   date-field"
                >

                    <option value="null"> Letter Type</option>
                    <option value="eot">EOT</option>
                    <option value="cos">COS</option>
                    <option value="ncr">NCR</option>
                    <option value="billing">Billing</option>
                    <option value="informative">Informative</option>
                    <option value="show-cause">Show Cause</option>
                    <option value="Design & Drawing">Design & Drawing</option>
                    <option value="P&P">P&P</option>
                    <option value="QAP">QAP</option>
                    <option value="Structure">Structure</option>
                    <option value="billing">Billing</option>
                    <option value="Q & ME">Q & ME</option>
                    <option value="BBS">BBS</option>
                    <option value="noc">NOC</option>
                    <option value="Road Safety">Road Safety</option>
                    <option value="Work Plan">Work Plan</option>
                    <option value="Drain">Drain</option>
                    <option value="Hydrology">Hydrology</option>
                    <option value="Survey">Survey</option>
                    <option value="Milestone">Milestone</option>
                    <option value="SiteProgress">SiteProgress</option>
                    <option value="query">Query</option>
                    <option value="other">Others</option>
                </select> */}
                <Select
                    options={LetterTypeOptions}
                    onChange={handleChange}
                    value={LetterTypeOptions?.find((item) => item.value === lettertype) || "null"}
                    placeholder="Select Letter-Type"
                    isSearchable
                    isClearable
                    noOptionsMessage={() => "No other options"}
                    className="attendance-input-field   date-field"
                    styles={CSSForFilterDropdown}
                />

                <hr className="field-cont-hr" />
            </div>
        </>
    )
}


const StatusFilter = ({ togglestatus, settoggleStatus }) => {
    const status = [
        { value: "null", label: "All" },
        { value: "active", label: "Active" },
        { value: "inactive", label: "Inactive" },
    ];

    const statusOptions = status.map((i) => ({
        value: i.value,
        label: i.label,
    }));

    const handleStatusChange = (option) => {
        if (!option) {
            settoggleStatus("null");

        }
        else {
            settoggleStatus(option.value);
        }

    }

    return (
        <>
            <div title="Status Filter" className="field-cont-div">
                <Status />
                <Select
                    className="attendance-input-field  date-field"
                    style={{ cursor: 'pointer' }}
                    options={statusOptions}
                    value={
                        statusOptions.find((item) => item.value === togglestatus) || "null"
                    }
                    onChange={handleStatusChange}
                    placeholder="Select Status"
                    styles={CSSForFilterDropdown}
                />

                <hr className="field-cont-hr" />
            </div>
        </>
    )
}


// const SubCompany = ({ toggleCompany, setToggleCompany }) => {

//     const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);

//     // Fetch sub-companies when the component mounts
//     useEffect(() => {
//         const fetchSubCompanies = async () => {
//             try {
//                 const response = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
//                 setSiteSubCompanyList(response.data);
//             } catch (error) {
//                 console.error('Error fetching sub-companies:', error);
//             }
//         };

//         fetchSubCompanies();
//     }, []);


//     // Event handlers
//     const handleCompanyChange = (e) => setToggleCompany(e.target.value);


//     return (
//         <>
//             {siteSubCompanyList?.length > 0 &&

//                 <div title="Company Filter" className="field-cont-div">
//                     <Building2 />

//                     <select
//                         onChange={handleCompanyChange}
//                         value={toggleCompany || 'null'}
//                         className="attendance-input-field date-field"
//                         style={{ cursor: 'pointer', }}
//                     >
//                         {siteSubCompanyList.filter(i => i.id !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c").map((company) => (
//                             <option key={company.id} value={company.id}>
//                                 {company.title}
//                             </option>
//                         ))}
//                     </select>
//                     <hr className="field-cont-hr" />
//                 </div>
//             }
//         </>
//     )
// }
const MonthModern = ({ cssType, usedIn, filterMonth, setFilterMonth }) => {
    const monthOptions = [
        { value: "1", label: "January" },
        { value: "2", label: "February" },
        { value: "3", label: "March" },
        { value: "4", label: "April" },
        { value: "5", label: "May" },
        { value: "6", label: "June" },
        { value: "7", label: "July" },
        { value: "8", label: "August" },
        { value: "9", label: "September" },
        { value: "10", label: "October" },
        { value: "11", label: "November" },
        { value: "12", label: "December" },
    ];

    const getValue = () => {
        return monthOptions.find((item) => item.value === String(filterMonth)) || null;
    };

    const handleMonthChange = (option) => {
        if (!option) {
            setFilterMonth(null);
            return;
        }
        setFilterMonth(option.value);
    };

    return (
        <div className="subcompany-modern-containers">
            <div className="subcompany-modern-wrappers">
                <div
                    className={cssType === "modern" && "subcompany-selectorssss"}
                    style={{ minHeight: usedIn === "normalTable" && "0px", height: usedIn === "normalTable" && "35px", backgroundColor: "white" }}
                >
                    <div
                        className={cssType === "modern" ? "subcompany-selectorssss-content" : "field-cont-div"}
                        style={{ width: cssType === "modern" && "100%" }}
                    >
                        <Calendar size={16} className="selector-iconss" />

                        <Select
                            key={filterMonth}
                            className="project-filter-select"
                            options={monthOptions}
                            value={getValue()}
                            onChange={handleMonthChange}
                            isClearable
                            placeholder="Select Month"
                            styles={getCSSForFilterDropdown("5")}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            menuShouldScrollIntoView={false}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
const Monthprefix0 = ({ cssType, usedIn, filterMonth, setFilterMonth }) => {
    const monthOptions = [
        { value: "01", label: "January" },
        { value: "02", label: "February" },
        { value: "03", label: "March" },
        { value: "04", label: "April" },
        { value: "05", label: "May" },
        { value: "06", label: "June" },
        { value: "07", label: "July" },
        { value: "08", label: "August" },
        { value: "09", label: "September" },
        { value: "10", label: "October" },
        { value: "11", label: "November" },
        { value: "12", label: "December" },
    ];

    const getValue = () => {
        return monthOptions.find((item) => item.value === String(filterMonth)) || null;
    };

    const handleMonthChange = (option) => {
        if (!option) {
            setFilterMonth(null);
            return;
        }
        setFilterMonth(option.value);
    };

    return (
        <div className="subcompany-modern-containers">
            <div className="subcompany-modern-wrappers">
                <div
                    className={cssType === "modern" && "subcompany-selectorssss"}
                    style={{ minHeight: usedIn === "normalTable" && "0px", height: usedIn === "normalTable" && "35px", backgroundColor: "white" }}
                >
                    <div
                        className={cssType === "modern" ? "subcompany-selectorssss-content" : "field-cont-div"}
                        style={{ width: cssType === "modern" && "100%" }}
                    >
                        <Calendar size={16} className="selector-iconss" />

                        <Select
                            key={filterMonth}
                            className="project-filter-select"
                            options={monthOptions}
                            value={getValue()}
                            onChange={handleMonthChange}
                            isClearable
                            placeholder="Select Month"
                            styles={getCSSForFilterDropdown("5")}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            menuShouldScrollIntoView={false}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

const YearModern = ({ cssType, usedIn, filterYear, setFilterYear }) => {
    const currentYear = new Date().getFullYear();

    const yearOptions = Array.from({ length: 11 }, (_, index) => {
        const year = currentYear - index;
        return { value: String(year), label: String(year) };
    });

    const getValue = () => {
        return yearOptions.find((item) => item.value === String(filterYear)) || null;
    };

    const handleYearChange = (option) => {
        if (!option) {
            setFilterYear(null);
            return;
        }
        setFilterYear(option.value);
    };

    return (
        <div className="subcompany-modern-containers">
            <div className="subcompany-modern-wrappers">
                <div
                    className={cssType === "modern" && "subcompany-selectorssss"}
                    style={{ minHeight: usedIn === "normalTable" && "0px", height: usedIn === "normalTable" && "35px", backgroundColor: "white" }}
                >
                    <div
                        className={cssType === "modern" ? "subcompany-selectorssss-content" : "field-cont-div"}
                        style={{ width: cssType === "modern" && "100%" }}
                    >
                        <Clock size={16} className="selector-iconss" />

                        <Select
                            key={filterYear}
                            className="project-filter-select"
                            options={yearOptions}
                            value={getValue()}
                            onChange={handleYearChange}
                            isClearable
                            placeholder="Select Year"
                            styles={getCSSForFilterDropdown("5")}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            menuShouldScrollIntoView={false}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

const SubCompanyModern = ({ cssType, usedIn, toggleCompany, setToggleCompany, width }) => {
    const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedCompany, setSelectedCompany] = useState(null);
    const dropdownRef = useRef(null);
    const [buffer, setBuffering] = useState(true); //buffering logic

    // Fetch sub-companies when the component mounts
    useEffect(() => {
        const fetchSubCompanies = async () => {
            setBuffering(true); //buffering logic // Start Buffering

            try {
                const response = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
                // Filter out the specific company
                const filteredList = response.data.filter(i => i.id !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c");
                setSiteSubCompanyList(filteredList);

                // Set selected company based on toggleCompany prop
                if (toggleCompany && toggleCompany !== 'null') {
                    const selected = filteredList.find(c => c.id === toggleCompany);
                    setSelectedCompany(selected);
                }
            } catch (error) {
                console.error('Error fetching sub-companies:', error);
            }
            finally {
                setBuffering(false); //buffering logic // End Buffering

            }
        };

        fetchSubCompanies();
    }, []);

    // Update selected company when toggleCompany prop changes
    useEffect(() => {
        if (toggleCompany && toggleCompany !== 'null') {
            const selected = siteSubCompanyList.find(c => c.id === toggleCompany);
            setSelectedCompany(selected);
        } else {
            setSelectedCompany(null);
        }
    }, [toggleCompany, siteSubCompanyList]);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
                setSearchTerm('');
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleCompanySelect = (company) => {
        setSelectedCompany(company);
        setToggleCompany(company.id);
        setIsOpen(false);
        setSearchTerm('');
    };

    const handleClear = () => {
        setSelectedCompany(null);
        setToggleCompany('null');
        setIsOpen(false);
    };

    const filteredCompanies = siteSubCompanyList.filter(company =>
        company.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const options = filteredCompanies.map(company => ({
        value: company.id,
        label: company.title
    }));

    const getValue = () => {

        return (
            options.find((item) => item.value === toggleCompany) || "null"
        );
    };

    const handleProjectChange = (option) => {



        if (!option) {

            setToggleCompany("null");

            return; // Ensure function exits when clearing selection
        }
        else {
            setToggleCompany(option.value);

        }



    };
    return (
        <div className="subcompany-modern-containers" >
            {filteredCompanies?.length > 0 && (
                <div className="subcompany-modern-wrappers">
                    <div className={cssType === "modern" && "subcompany-selectorssss"} style={{ minHeight: usedIn === "normalTable" && "0px", height: usedIn === "normalTable" && "35px", backgroundColor: "white" }}>
                        <div className={cssType === "modern" ? "subcompany-selectorssss-content" : "field-cont-div"} style={{ width: cssType === "modern" && "100%", }}>
                            {buffer ? (
                                <div className="spinner-vsmall"></div>
                            ) : (
                                <Building2 size={16} className="selector-iconss" />
                            )}

                            <Select
                                key={toggleCompany}
                                className="project-filter-select"
                                options={options}
                                value={getValue()}
                                onChange={handleProjectChange}
                                isClearable
                                placeholder="Select Company"
                                styles={CSSForFilterDropdown10VW}
                                menuPortalTarget={document.body} // This portals the menu to body
                                menuPosition="fixed" // Fixed positioning
                                menuShouldScrollIntoView={false} // Prevents scrolling issues
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
const DivisionModern = ({ cssType, usedIn, subCompany, division, setDivision, width }) => {
    const [divisionList, setDivisionList] = useState([]);
    const [buffer, setBuffering] = useState(true);

    useEffect(() => {
        const fetchDivisions = async () => {
            setBuffering(true);
            try {
                const response = await axios.get(`${BASE_URL}/siteproject/divisionfilter/${subCompany}/`);
                setDivisionList(response.data);
            } catch (error) {
                console.error('Error fetching divisions:', error);
            } finally {
                setBuffering(false);
            }
        };

        fetchDivisions();
    }, [subCompany]);

    const options = divisionList.map(company => ({
        value: company.id,
        label: company.name
    }));

    const getValue = () => {
        return options.find((item) => item.value === division) || null;
    };

    const handleDivisionChange = (option) => {
        if (!option) {
            setDivision("null");
            return;
        }
        setDivision(option.value);
    };

    return (
        <div className="subcompany-modern-containers">
            {options?.length > 0 && (
                <div className="subcompany-modern-wrappers">
                    <div
                        className={cssType === "modern" && "subcompany-selectorssss"}
                        style={{ minHeight: usedIn === "normalTable" && "0px", height: usedIn === "normalTable" && "35px", backgroundColor: "white" }}
                    >
                        <div
                            className={cssType === "modern" ? "subcompany-selectorssss-content" : "field-cont-div"}
                            style={{ width: cssType === "modern" && "100%" }}
                        >
                            {buffer ? (
                                <div className="spinner-vsmall"></div>
                            ) : (
                                <Building2 size={16} className="selector-iconss" />
                            )}

                            <Select
                                key={division}
                                className="project-filter-select"
                                options={options}
                                value={getValue()}
                                onChange={handleDivisionChange}
                                isClearable
                                placeholder="Select Division"
                                styles={CSSForFilterDropdown10VW}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                menuShouldScrollIntoView={false}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
const AEFilter = ({ cssType, usedIn, subCompany, ae, setAe, width }) => {
    const [aeList, setAEList] = useState([]);
    const [buffer, setBuffering] = useState(true);

    useEffect(() => {
        const fetchAEs = async () => {
            setBuffering(true);
            try {
                const response = await axios.get(`${BASE_URL}/siteproject/employeefilterbyproject/null/${subCompany}/`);
                setAEList(response.data);
            } catch (error) {
                console.error('Error fetching AEs:', error);
            } finally {
                setBuffering(false);
            }
        };

        fetchAEs();
    }, [subCompany]);

    const options = aeList.filter(i => i.emp_role === "AuthorityEngineer").map(employee => ({
        value: employee.id,
        label: employee.name
    }));

    const getValue = () => {
        return options.find((item) => item.value === ae) || null;
    };

    const handleAeChange = (option) => {
        if (!option) {
            setAe("null");
            return;
        }
        setAe(option.value);
    };


    return (
        <div className="subcompany-modern-containers">
            {options?.length > 0 && (
                <div className="subcompany-modern-wrappers">
                    <div
                        className={cssType === "modern" && "subcompany-selectorssss"}
                        style={{ minHeight: usedIn === "normalTable" && "0px", height: usedIn === "normalTable" && "35px", backgroundColor: "white" }}
                    >
                        <div
                            className={cssType === "modern" ? "subcompany-selectorssss-content" : "field-cont-div"}
                            style={{ width: cssType === "modern" && "100%" }}
                        >
                            {buffer ? (
                                <div className="spinner-vsmall"></div>
                            ) : (
                                <User size={16} className="selector-iconss" />
                            )}

                            <Select
                                key={ae}
                                className="project-filter-select"
                                options={options}
                                value={getValue()}
                                onChange={handleAeChange}
                                isClearable
                                placeholder="Select AE"
                                styles={CSSForFilterDropdown10VW}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                menuShouldScrollIntoView={false}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const DesignationModern = ({ cssType, usedIn, division, subCompany, designation, setDesignation, width }) => {
    const [designationList, setDesignationList] = useState([]);
    const [buffer, setBuffering] = useState(true);

    useEffect(() => {
        const fetchDesignations = async () => {
            setBuffering(true);
            try {
                const response = await axios.get(`${BASE_URL}/siteproject/designationfilterbysubcompanycount/${division}/active/${subCompany}/`);
                setDesignationList(response.data);
            } catch (error) {
                console.error('Error fetching designations:', error);
            } finally {
                setBuffering(false);
            }
        };

        fetchDesignations();
    }, [division, subCompany]);

    const options = designationList.map(d => ({
        value: d.id,
        label: d.title
    }));

    const getValue = () => {
        return options.find((item) => item.value === designation) || null;
    };

    const handleDesignationChange = (option) => {
        if (!option) {
            setDesignation("null");
            return;
        }
        setDesignation(option.value);
    };

    return (
        <div className="subcompany-modern-containers">
            {options?.length > 0 && (
                <div className="subcompany-modern-wrappers">
                    <div
                        className={cssType === "modern" && "subcompany-selectorssss"}
                        style={{ minHeight: usedIn === "normalTable" && "0px", height: usedIn === "normalTable" && "35px", backgroundColor: "white" }}
                    >
                        <div
                            className={cssType === "modern" ? "subcompany-selectorssss-content" : "field-cont-div"}
                            style={{ width: cssType === "modern" && "100%" }}
                        >
                            {buffer ? (
                                <div className="spinner-vsmall"></div>
                            ) : (
                                <UserCog size={16} className="selector-iconss" />
                            )}

                            <Select
                                key={designation}
                                className="project-filter-select"
                                options={options}
                                value={getValue()}
                                onChange={handleDesignationChange}
                                isClearable
                                placeholder="Select Designation"
                                styles={CSSForFilterDropdown10VW}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                menuShouldScrollIntoView={false}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
const ContractorModern = ({ subcompany, project, cssType, usedIn, contractorId, setcontractorId, buffer }) => {
    const [contractorlist, setContractorList] = useState([]);

    const getContractor = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/contractorbyproject/${project}/${subcompany}/`);
            setContractorList(res.data);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getContractor();
    }, [project, subcompany]);
    const contractorOptions = contractorlist?.map((i) => ({
        value: i.id,
        label: i.name,
    })) || [];

    const getValue = () => {
        return contractorOptions.find((item) => item.value === contractorId) || null;
    };

    const handleContractorChange = (option) => {
        if (!option) {
            setcontractorId("null");
            return;
        }
        setcontractorId(option.value);
    };

    return (
        <div className="subcompany-modern-containers">
            {contractorOptions?.length > 0 && (
                <div className="subcompany-modern-wrappers">
                    <div
                        className={cssType === "modern" && "subcompany-selectorssss"}
                        style={{ minHeight: usedIn === "normalTable" && "0px", height: usedIn === "normalTable" && "35px", backgroundColor: "white" }}
                    >
                        <div
                            className={cssType === "modern" ? "subcompany-selectorssss-content" : "field-cont-div"}
                            style={{ width: cssType === "modern" && "100%" }}
                        >
                            {buffer ? (
                                <div className="spinner-vsmall"></div>
                            ) : (
                                <CircularGrid size={16} className="selector-iconss" />
                            )}

                            <Select
                                key={contractorId}
                                className="project-filter-select"
                                options={contractorOptions}
                                value={getValue()}
                                onChange={handleContractorChange}
                                isClearable
                                placeholder="All Contractors"
                                styles={getCSSForFilterDropdown("40")}
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                menuShouldScrollIntoView={false}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};
const VehicleModern = ({ cssType, toggleProject, toggleSubCompany, usedIn, toggleVehicle, setToggleVehicle, width }) => {
    const [siteSubVehicleList, setSiteSubVehicleList] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedCompany, setSelectedCompany] = useState(null);
    const dropdownRef = useRef(null);
    const [buffer, setBuffering] = useState(true); //buffering logic

    useEffect(() => {
        const fetchVehicles = async () => {
            setBuffering(true); //buffering logic // Start Buffering

            try {
                const response = await axios.get(`${BASE_URL}/siteproject/vehiclefilterapibyproj/${toggleProject}/${toggleSubCompany}/`);
                // Filter out the specific company
                setSiteSubVehicleList(response.data);

                if (toggleVehicle && toggleVehicle !== 'null') {
                    const selected = siteSubVehicleList.find(c => c.id === toggleVehicle);
                    setSelectedCompany(selected);
                }
            } catch (error) {
                console.error('Error fetching vehicles:', error);
            }
            finally {
                setBuffering(false); //buffering logic // End Buffering

            }
        };

        fetchVehicles();
    }, [toggleProject, toggleSubCompany]);

    // Update selected vehicle when toggleVehicle prop changes
    useEffect(() => {
        if (toggleVehicle && toggleVehicle !== 'null') {
            const selected = siteSubVehicleList.find(v => v.id === toggleVehicle);
            setSelectedCompany(selected);
        } else {
            setSelectedCompany(null);
        }
    }, [toggleVehicle, siteSubVehicleList]);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
                setSearchTerm('');
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);






    const options = siteSubVehicleList.map(vehicle => ({
        value: vehicle.id,
        label: `${vehicle.vehicle_num}-${vehicle.name}`
    }));

    const getValue = () => {

        return (
            options.find((item) => item.value === toggleVehicle) || "null"
        );
    };

    const handleVehicleChange = (option) => {



        if (!option) {

            setToggleVehicle(null);

            return; // Ensure function exits when clearing selection
        }
        else {
            setToggleVehicle(option.value);

        }



    };
    return (
        <div className="subcompany-modern-containers" >

            <div className="subcompany-modern-wrappers">
                <div className={cssType === "modern" && "subcompany-selectorssss"} style={{ minHeight: usedIn === "normalTable" && "0px", height: usedIn === "normalTable" && "35px" }}>
                    <div className={cssType === "modern" ? "subcompany-selectorssss-content" : "field-cont-div"} style={{ width: cssType === "modern" && "100%", }}>
                        {buffer ? (
                            <div className="spinner-vsmall"></div>
                        ) : (
                            <CarFront size={16} className="selector-iconss" />
                        )}

                        <Select
                            key={toggleVehicle}
                            className="project-filter-select"
                            options={options}
                            value={getValue()}
                            onChange={handleVehicleChange}
                            isClearable
                            placeholder="Select Vehicle"
                            styles={CSSForFilterDropdown10VW}
                            menuPortalTarget={document.body} // This portals the menu to body
                            menuPosition="fixed" // Fixed positioning
                            menuShouldScrollIntoView={false} // Prevents scrolling issues
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

const SubCompany = ({ toggleCompany, setToggleCompany }) => {

}


const Projects = ({ toggleProject, toggleProjectName, setToggleProject, toggleProjectCode, cssType, setToggleProjectCode, setToggleProjectName, subcompany, value, title, authority, usedFor, error, inputvalue, SetErrors, multiProject = false }) => {
    const [projectList, setProjectList] = useState([]);
    const [projectList2, setProjectList2] = useState([]);
    const [projectList3, setProjectList3] = useState([]);
    const [buffer, setBuffering] = useState(true); //buffering logic

    useEffect(() => {
        if (!subcompany) return;

        const fetchProjects = async () => {
            setBuffering(true); //buffering logic // Start Buffering
            try {
                const role = sessionStorage.getItem("sitemanagement_role");
                const empId = sessionStorage.getItem("sitemanagement_emp_id");
                const url =
                    role === "AuthorityEngineer"
                        ? `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${empId}/${subcompany}/null/null/`
                        : role === "DataEntryOperator"
                            ? `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/null/${subcompany}/${empId}/null/`
                            : `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${authority ? authority : "null"}/${subcompany}/null/null/`;

                const response = await axios.get(url);
                const sortedProjects = sortProjects(response.data, "site_prcode");
                if (toggleProject) {
                    setProjectList(
                        sortedProjects.map(({ id, site_prcode, project_short_name }) => ({
                            value: id,
                            label: `${site_prcode}-${project_short_name}`,
                        }))
                    );
                }
                if (toggleProjectName) {
                    setProjectList2(
                        sortedProjects.map(({ id, site_prcode, project_short_name }) => ({
                            value: project_short_name,
                            label: `${site_prcode}-${project_short_name}`,
                        }))
                    );
                }
                if (toggleProjectCode) {
                    setProjectList3(
                        sortedProjects.map(({ id, site_prcode, project_short_name }) => ({
                            value: site_prcode,
                            label: `${site_prcode}-${project_short_name}`,
                        }))
                    );
                }
            } catch (error) {
                console.error("Error fetching projects:", error);
            } finally {
                setBuffering(false); //buffering logic // End Buffering
            }
        };

        fetchProjects();
    }, [subcompany, authority]);

    const handleProjectChange = (option) => {

        if (error) {
            SetErrors((prev) => ({ ...prev, project: "" }));
        }

        if (!option) {
            if (multiProject) {
                setToggleProject([]); // ✅ clear multi select
                setToggleProjectName([]);
                setToggleProjectCode([]);
                return;
            }
            if (value === "id") {
                setToggleProject("null");
            } if (value === "name") {
                setToggleProjectName("");
            }
            if (value === "projectcode") {
                setToggleProjectCode("null");
            }
            return; // Ensure function exits when clearing selection
        }

        if (multiProject) {
            const selectedValues = option.map((item) => item.value);
            if (value === "id") setToggleProject(selectedValues);
            if (value === "name") setToggleProjectName(selectedValues);
            if (value === "projectcode") setToggleProjectCode(selectedValues);
            return;
        }

        if (value === "id") {
            setToggleProject(option.value);
        } if (value === "name") {
            setToggleProjectName(option.value);
        }
        if (value === "projectcode") {
            setToggleProjectCode(option.value);
        }
    };

    const getValue = () => {
        if (multiProject) {
            if (value === "id")
                return projectList.filter((item) => toggleProject?.includes(item.value));
            if (value === "name")
                return projectList2.filter((item) =>
                    toggleProjectName?.includes(item.value)
                );
            if (value === "projectcode")
                return projectList3.filter((item) =>
                    toggleProjectCode?.includes(item.value)
                );
            return [];
        } else {
            if (value === "id")
                return projectList.find((item) => item.value === toggleProject) || "null";
            if (value === "name")
                return projectList2.find((item) => item.value === toggleProjectName) || "";
            if (value === "projectcode")
                return (
                    projectList3.find((item) => item.value === toggleProjectCode) || "null"
                );
            return "null";
        }
    };



    // console.log("value")
    // console.log(value)
    // console.log(value, toggleProject, toggleProjectName)

    return (
        <>
            {usedFor === "filter" ?
                <div className="subcompany-modern-containers" style={{ width: cssType === "modern" && "100%" }}>
                    {projectList?.length > 0 && (
                        <div className="subcompany-modern-wrappers">
                            <div className={cssType === "modern" && "subcompany-selectorssss"} style={{ background: "white" }}>
                                <div className={cssType === "modern" ? "subcompany-selectorssss-content" : "field-cont-div"} style={{ width: cssType === "modern" && "100%", backgroundColor: "white" }}>
                                    {buffer ? (
                                        <div className="spinner-vsmall"></div>
                                    ) : (
                                        <SearchCheck size={16} className="selector-iconss" />
                                    )}
                                    <Select
                                        key={toggleProject || toggleProjectName || toggleProjectCode}
                                        className="project-filter-select"
                                        options={projectList}
                                        value={getValue()}
                                        onChange={handleProjectChange}
                                        isClearable
                                        placeholder="Select Project"
                                        styles={CSSForFilterDropdown}
                                        menuPortalTarget={document.body} // This portals the menu to body
                                        menuPosition="fixed" // Fixed positioning
                                        menuShouldScrollIntoView={false} // Prevents scrolling issues
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </div> :
                usedFor === "form" ?
                    // <div title="Site Projects" className="flex-column form-group-selectt">
                    //     <label htmlFor={inputvalue} className="form-labels font-weight500 font-size-subheading">
                    //         Site Project <span className="required">*</span>
                    //     </label>
                    //     <br />
                    //     <Select
                    //         options={projectList}
                    //         onChange={handleProjectChange}
                    //         value={
                    //             value === "id"
                    //                 ? projectList.find((item) => item.value === toggleProject) || "null"
                    //                 : value === "name"
                    //                     ? projectList2.find((item) => item.value === toggleProjectName) || ""
                    //                     : value === "projectcode" ?
                    //                         projectList3.find((item) => item.value === toggleProjectCode) || "null"
                    //                         : "null"
                    //         }
                    //         placeholder="Select a Project"
                    //         isSearchable
                    //         isClearable
                    //         noOptionsMessage={() => "No other options"}
                    //         styles={title === `small` ? CSSForSelectSmallWidth : CSSForSelect}
                    //     />



                    //     {error && <span className="error-message font-size-text">{error}</span>}
                    // </div> 
                    // 
                    <div title="Site Projects" className={`${cssType === "modern" ? "form-field" : ""} flex-column form-group-selectt`}>
                        <label
                            htmlFor={inputvalue}
                            className={`${cssType === "modern" ? "" : "form-labels font-weight500 font-size-subheading"}`}
                        >
                            {multiProject ? "Site Projects" : "Site Project"}{" "}
                            <span className="required">*</span>
                        </label>
                        <Select
                            options={projectList}
                            onChange={handleProjectChange}
                            value={getValue()}
                            isMulti={multiProject} // ✅ added here too
                            placeholder={
                                multiProject ? "Select Multiple Projects" : "Select a Project"
                            }
                            isSearchable
                            isClearable
                            noOptionsMessage={() => "No other options"}
                            styles={title === "small" ? CSSForSelectSmallWidth : multiProject ? CSSForMultiSelectOption : cssType === "modern" ? CSSForSelectModern : CSSForSelect}
                        />
                        {error && (
                            <span className="error-message font-size-text">{error}</span>
                        )}
                    </div>
                    : ""
            }
        </>
    );
};

const MonthOptions = ({ error, SetErrors, setToggleMonth, toggleMonth, inputvalue }) => {

    const months = [
        { value: "01", label: "January" },
        { value: "02", label: "February" },
        { value: "03", label: "March" },
        { value: "04", label: "April" },
        { value: "05", label: "May" },
        { value: "06", label: "June" },
        { value: "07", label: "July" },
        { value: "08", label: "August" },
        { value: "09", label: "September" },
        { value: "10", label: "October" },
        { value: "11", label: "November" },
        { value: "12", label: "December" },


    ]

    const monthOptions = months.map((i) => ({
        label: i.label,
        value: i.value
    }))

    const handleMonthChange = (option) => {
        if (error) {
            SetErrors((prev) => ({ ...prev, month: "" }))
        }
        if (!option) {
            setToggleMonth("null")
        }
        else {
            setToggleMonth(option.value)
        }
    };

    return (
        <>
            <div title="Month" className="flex-column form-group-selectt">
                <label htmlFor={inputvalue} className="form-labels font-weight500 font-size-subheading">
                    Month <span className="required">*</span>
                </label>
                <br />
                <Select
                    options={monthOptions}
                    onChange={handleMonthChange}
                    value={
                        monthOptions.find((item) => item.value === toggleMonth) || "null"
                    }
                    placeholder="Select a Month"
                    isSearchable
                    isClearable
                    noOptionsMessage={() => "No other options"}
                    styles={CSSForSelect15vWWidth}
                />



                {error && <span className="error-message font-size-text">{error}</span>}
            </div>
        </>
    )

};

const YearOptions = ({ error, SetErrors, setToggleYear, toggleYear, inputvalue }) => {

    const currentYear = new Date().getFullYear();
    const years = [];
    for (let y = 2015; y <= currentYear + 1; y++) {
        years.push({ value: String(y), label: String(y) });
    }

    const yearOptions = years
        .map((i) => ({
            label: i.label,
            value: i.value
        }))
        .reverse();


    const handleYearChange = (option) => {
        if (error) {
            SetErrors((prev) => ({ ...prev, year: "" }));
        }
        if (!option) {
            setToggleYear("null");
        } else {
            setToggleYear(option.value);
        }
    };

    return (
        <>
            <div title="Year" className="flex-column form-group-selectt">
                <label htmlFor={inputvalue} className="form-labels font-weight500 font-size-subheading">
                    Year <span className="required">*</span>
                </label>
                <br />
                <Select
                    options={yearOptions}
                    onChange={handleYearChange}
                    value={
                        yearOptions.find((item) => item.value === toggleYear) || "null"
                    }
                    placeholder="Select a Year"
                    isSearchable
                    isClearable
                    noOptionsMessage={() => "No other options"}
                    styles={CSSForSelect15vWWidth}
                />

                {error && <span className="error-message font-size-text">{error}</span>}
            </div>
        </>
    );
};


const EmployeeFilter = ({ project, toggleEmployee, cssType, toggleEmployeeName, settoggleEmployee, toggleEmployeeCode, status, settoggleEmployeeCode, settoggleEmployeeName, subcompany, value, title, authority, usedFor, error, inputvalue, toggleCompany }) => {
    const [employeeList, setEmployeeList] = useState([]);
    const [employeeList2, setEmployeeList2] = useState([]);
    const [employeeList3, setEmployeeList3] = useState([]);
    const [buffer, setBuffering] = useState(true); //buffering logic


    useEffect(() => {
        if (project === "null") return;

        const fetchEmployeeData = async () => {
            setBuffering(true); //buffering logic // Start Buffering
            try {
                const res = await axios.get(`${BASE_URL}/siteproject/employeefilterbyproject/${project}/${toggleCompany}/`);

                const sortedData = res.data.sort((a, b) => a.emp_code.localeCompare(b.emp_code));
                if (toggleEmployee) {
                    setEmployeeList(
                        sortedData.map(({ id, emp_code, name }) => ({
                            value: id,
                            label: `${emp_code}-${name}`,
                        }))
                    );
                }
                if (toggleEmployeeName) {
                    setEmployeeList2(
                        sortedData.map(({ id, emp_code, name }) => ({
                            value: name,
                            label: `${emp_code}-${name}`,
                        }))
                    );
                }
                if (toggleEmployeeCode) {
                    setEmployeeList3(
                        sortedData.map(({ id, emp_code, name }) => ({
                            value: emp_code,
                            label: `${emp_code}-${name}`,
                        }))
                    );
                }
            } catch (error) {
                console.error("Error fetching projects:", error);
            } finally {
                setBuffering(false); //buffering logic // End Buffering
            }
        };

        fetchEmployeeData();
    }, [project, toggleCompany]);

    const handleEmployeeChange = (option) => {
        if (!option) {
            if (value === "id") {
                settoggleEmployee("null");
            } if (value === "name") {
                settoggleEmployeeName("");
            }
            if (value === "empcode") {
                settoggleEmployeeCode("null");
            }
            return; // Ensure function exits when clearing selection
        }

        if (value === "id") {
            settoggleEmployee(option.value);
        } if (value === "name") {
            settoggleEmployeeName(option.value);
        }
        if (value === "empcode") {
            settoggleEmployeeCode(option.value);
        }
    };
    return (
        <>
            {usedFor === "filter" ?
                <div title="Employee Filter" className="field-cont-div">
                    {buffer ? <div className="spinner-vsmall"></div> : <Employee />}
                    <Select
                        key={toggleEmployee || toggleEmployeeName || toggleEmployeeCode} // Forces re-render
                        className="attendance-input-field  date-field"
                        style={{ cursor: 'pointer' }}
                        options={employeeList}
                        value={
                            value === "id"
                                ? employeeList.find((item) => item.value === toggleEmployee) || "null"
                                : value === "name"
                                    ? employeeList2.find((item) => item.value === toggleEmployeeName) || ""
                                    : value === "empcode" ?
                                        employeeList3.find((item) => item.value === toggleEmployeeCode) || "null"
                                        : "null"
                        }
                        onChange={handleEmployeeChange}
                        // style={{ cursor: 'pointer' }}
                        isClearable
                        placeholder="Select an Employee"
                        styles={CSSForFilterDropdown}
                    />

                    <hr className="field-cont-hr" />

                </div> :
                usedFor === "form" ?
                    <div title="Site Employees" className={`${cssType === "modern" ? "form-field" : ""} flex-column form-group-selectt`}>
                        <label htmlFor={inputvalue} className={`${cssType === "modern" ? "" : "form-labels font-weight500 font-size-subheading"}`}
                        >
                            Site Employee <span className="required">*</span>
                        </label>
                        <Select
                            options={employeeList}
                            onChange={handleEmployeeChange}
                            value={
                                value === "id"
                                    ? employeeList.find((item) => item.value === toggleEmployee) || "null"
                                    : value === "name"
                                        ? employeeList2.find((item) => item.value === toggleEmployeeName) || ""
                                        : value === "empcode" ?
                                            employeeList3.find((item) => item.value === toggleEmployeeCode) || "null"
                                            : "null"
                            }
                            placeholder="Select an Employee"
                            isSearchable
                            isClearable
                            noOptionsMessage={() => "No other options"}
                            styles={title === "small" ? CSSForSelectSmallWidth : cssType === "modern" ? CSSForSelectModern : CSSForSelect}
                        />



                        {error && <span className="error-message font-size-text">{error}</span>}
                    </div> : ""
            }
        </>
    );
};



// const LetterNumberFilter = ({ toggleLetter, toggleLetterName, settoggleLetter, settoggleLetterName, project, value }) => {
//     const [letterList, setletterList] = useState([]);
//     const [letterList2, setletterList2] = useState([]);

//     useEffect(() => {
//         if (!project) return;

//         const fetchContractor = async () => {
//             try {
//                 const res = await axios.get(`${BASE_URL}/siteproject/letterrecordfilterletter/${project}/`);
//                 const contractorData = res.data;

//                 if (toggleLetter) {
//                     setletterList(
//                         contractorData.map(({ id, letter_num }) => ({
//                             value: id,
//                             label: `${letter_num}`,
//                         }))
//                     );
//                 }
//                 if (toggleLetterName) {
//                     setletterList2(
//                         contractorData.map(({ id, name }) => ({
//                             value: name,
//                             label: `${name}`,
//                         }))
//                     );
//                 }

//             } catch (error) {
//                 console.error("Error fetching projects:", error);
//             }
//         };

//         fetchContractor();
//     }, [project]);

//     const handlecontractor = (option) => {
//         if (!option) {
//             if (value === "id") {
//                 settoggleLetter("null");
//             } if (value === "name") {
//                 settoggleLetterName("");
//             }
//             return; // Ensure function exits when clearing selection
//         }

//         if (value === "id") {
//             settoggleLetter(option.value);
//         } if (value === "name") {
//             settoggleLetterName(option.value);
//         }

//     };






//     return (
//         <>

//             <div title="Contractor Filter" className="field-cont-div">
//                 <SearchSmall />
//                 <Select
//                     key={toggleLetter || toggleLetterName} // Forces re-render
//                     className="attendance-input-field  date-field"

//                     options={letterList}
//                     value={
//                         value === "id"
//                             ? letterList.find((item) => item.value === toggleLetter) || "null"
//                             : value === "name"
//                                 ? letterList2.find((item) => item.value === toggleLetterName) || ""
//                                 : "null"
//                     }
//                     onChange={handlecontractor}
//                     isClearable
//                     placeholder="Search Letter Number"
//                     styles={{
//                         control: (provided) => ({
//                             ...provided,
//                             backgroundColor: "transparent",
//                             border: "none",
//                             boxShadow: "none",
//                             padding: "0.6rem 0.5rem",
//                             textTransform: "capitalize",
//                             width: "16vw"
//                         }),
//                         placeholder: (provided) => ({ ...provided, color: "#707070" }),
//                         menu: (provided) => ({ ...provided, zIndex: 9999 }),
//                         menuPortal: (base) => ({ ...base, zIndex: 9999 }),
//                         singleValue: (provided) => ({ ...provided, color: "#707070" }),
//                         dropdownIndicator: (provided) => ({
//                             ...provided,
//                             filter: "invert(50%)",
//                             cursor: "pointer",
//                             left: "9.5rem",
//                             // width: "20px",
//                             height: "20px",
//                             fontSize: "12px",
//                         }),
//                         option: (provided, state) => ({
//                             ...provided,
//                             fontSize: "12px",
//                             color: state.isSelected ? "#ffffff" : "#707070",
//                             backgroundColor: state.isSelected ? "#2576bc" : state.isFocused ? "#ffffff" : "#fff",
//                             cursor: "pointer",
//                             "&:hover": { backgroundColor: "#2576bc", color: "#fff" },
//                         }),
//                     }}
//                 />

//                 <hr className="field-cont-hr" />
//             </div>
//         </>
//     );
// };




const LetterNumberFilter = ({
    toggleLetter,
    toggleLetterName,
    settoggleLetter,
    settoggleLetterName,
    project,
    workperformedby,
    status,
    lettertype,
    value, subCompany
}) => {
    const [letterList, setletterList] = useState([]);
    const [letterList2, setletterList2] = useState([]);
    const [visibleCount, setVisibleCount] = useState(100);

    useEffect(() => {
        let isMounted = true;

        const fetchContractor = async () => {
            try {
                const res = await axios.get(
                    `${BASE_URL}/siteproject/letterrecordfilterletter/${project}/null/${lettertype}/${workperformedby}/${status}/${subCompany}/`
                );
                if (!isMounted) return;

                const formattedData = res.data.map(({ id, letter_num }) => ({
                    value: id,
                    label: letter_num,
                }));

                setletterList(formattedData);
                setletterList2(formattedData);
            } catch (error) {
                console.error("Error fetching projects:", error);
            }
        };

        if (project !== "null") fetchContractor();

        return () => {
            isMounted = false;
        };
    }, [project, workperformedby, lettertype, status, subCompany]);

    const handlecontractor = (option) => {
        if (!option) {
            if (value === "id") settoggleLetter("null");
            if (value === "name") settoggleLetterName("");
            return;
        }

        if (value === "id") settoggleLetter(option.value);
        if (value === "name") settoggleLetterName(option.value);
    };

    // choose which list to show
    const currentList = value === "id" ? letterList : letterList2;
    const limitedOptions = currentList.slice(0, visibleCount);

    // Custom dropdown menu with Load More
    const MenuList = (props) => {
        const childrenArray = React.Children.toArray(props.children);
        const limitedChildren = childrenArray.slice(0, visibleCount);

        return (
            <components.MenuList {...props}>
                {limitedChildren}
                {visibleCount < currentList.length && (
                    <div
                        style={{
                            padding: "8px",
                            textAlign: "center",
                            cursor: "pointer",
                            color: "#2576bc",
                            fontWeight: "bold",
                            fontSize: "12px",
                        }}
                        onClick={(e) => {
                            e.stopPropagation();
                            setVisibleCount((prev) => prev + 100);
                        }}
                    >
                        + Load More
                    </div>
                )}
            </components.MenuList>
        );
    };


    return (
        <div title="Contractor Filter" className="field-cont-div">
            <SearchBig />
            <Select
                key={toggleLetter || toggleLetterName}
                className="attendance-input-field date-field"
                options={currentList}
                value={
                    value === "id"
                        ? letterList.find((item) => item.value === toggleLetter) || null
                        : value === "name"
                            ? letterList2.find((item) => item.value === toggleLetterName) || null
                            : null
                }
                onChange={handlecontractor}
                isClearable
                placeholder="Search Letter Number"
                components={{ MenuList }} // 👈 inject custom MenuList
                styles={{
                    control: (provided) => ({
                        ...provided,
                        backgroundColor: "transparent",
                        border: "none",
                        boxShadow: "none",
                        padding: "0.6rem 0.5rem",
                        textTransform: "capitalize",
                        width: "16vw",
                    }),
                    placeholder: (provided) => ({
                        ...provided,
                        color: "#707070",
                    }),
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    singleValue: (provided) => ({ ...provided, color: "#707070" }),
                    dropdownIndicator: (provided) => ({
                        ...provided,
                        filter: "invert(50%)",
                        cursor: "pointer",
                        left: "9.5rem",
                        height: "20px",
                        fontSize: "12px",
                    }),
                    option: (provided, state) => ({
                        ...provided,
                        fontSize: "12px",
                        color: state.isSelected ? "#ffffff" : "#707070",
                        backgroundColor: state.isSelected
                            ? "#2576bc"
                            : state.isFocused
                                ? "#f0f0f0"
                                : "#fff",
                        cursor: "pointer",
                        "&:hover": { backgroundColor: "#2576bc", color: "#fff" },
                    }),
                }}
            />

            <hr className="field-cont-hr" />
        </div>
    );
};



const ContractorFilter = ({ toggleContractor, toggleContractorName, subcompany, settoggleContractor, settoggleContractorName, project, value }) => {
    const [contractorList, setcontractorList] = useState([]);
    const [contractorList2, setcontractorList2] = useState([]);

    useEffect(() => {
        if (!project) return;

        const fetchContractor = async () => {
            try {
                const res = await axios.get(`${BASE_URL}/siteproject/contractorbyproject/${project}/${subcompany}/`);
                const contractorData = res.data;

                if (toggleContractor) {
                    setcontractorList(
                        contractorData.map(({ id, name }) => ({
                            value: id,
                            label: `${name}`,
                        }))
                    );
                }
                if (toggleContractorName) {
                    setcontractorList2(
                        contractorData.map(({ id, name }) => ({
                            value: name,
                            label: `${name}`,
                        }))
                    );
                }

            } catch (error) {
                console.error("Error fetching projects:", error);
            }
        };

        fetchContractor();
    }, [project, subcompany]);

    const handlecontractor = (option) => {
        if (!option) {
            if (value === "id") {
                settoggleContractor("null");
            } if (value === "name") {
                settoggleContractorName("");
            }
            return; // Ensure function exits when clearing selection
        }

        if (value === "id") {
            settoggleContractor(option.value);
        } if (value === "name") {
            settoggleContractorName(option.value);
        }

    };






    return (
        <>

            <div title="Contractor Filter" className="field-cont-div">
                <ContactorIcon />
                <Select
                    key={toggleContractor || toggleContractorName} // Forces re-render
                    className="attendance-input-field  date-field"

                    options={contractorList}
                    value={
                        value === "id"
                            ? contractorList.find((item) => item.value === toggleContractor) || "null"
                            : value === "name"
                                ? contractorList2.find((item) => item.value === toggleContractorName) || ""
                                : "null"
                    }
                    onChange={handlecontractor}
                    isClearable
                    placeholder="Select a Contractor"
                    styles={{
                        control: (provided) => ({
                            ...provided,
                            backgroundColor: "transparent",
                            border: "none",
                            boxShadow: "none",
                            padding: "0.6rem 0.5rem",
                            textTransform: "capitalize",
                            width: "16vw"
                        }),
                        placeholder: (provided) => ({ ...provided, color: "#707070" }),
                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        singleValue: (provided) => ({ ...provided, color: "#707070" }),
                        dropdownIndicator: (provided) => ({
                            ...provided,
                            filter: "invert(50%)",
                            cursor: "pointer",
                            left: "9.5rem",
                            // width: "20px",
                            height: "20px",
                            fontSize: "12px",
                        }),
                        option: (provided, state) => ({
                            ...provided,
                            fontSize: "12px",
                            color: state.isSelected ? "#ffffff" : "#707070",
                            backgroundColor: state.isSelected ? "#2576bc" : state.isFocused ? "#ffffff" : "#fff",
                            cursor: "pointer",
                            "&:hover": { backgroundColor: "#2576bc", color: "#fff" },
                        }),
                    }}
                />

                <hr className="field-cont-hr" />
            </div>
        </>
    );
};
const CoordinatorFilter = ({ toggleCoordinator, toggleCoordinatorName, settoggleCoordinator, settoggleCoordinatorName, project, value, subcompany }) => {
    const [coordinatorList, setCoordinatorList] = useState([]);
    const [coordinatorList2, setCoordinatorList2] = useState([]);

    useEffect(() => {

        const fetchCoordinator = async () => {
            try {
                const res = await axios.get(`${BASE_URL}/siteproject/employeefilterbyproject/null/${subcompany}/`);
                const coordinatorData = res.data;

                if (toggleCoordinator) {
                    setCoordinatorList(
                        coordinatorData?.filter(i => i.emp_role === "DataEntryOperator")?.map(({ id, name }) => ({
                            value: id,
                            label: `${name}`,
                        }))
                    );
                }
                if (toggleCoordinatorName) {
                    setCoordinatorList2(
                        coordinatorData?.filter(i => i.emp_role === "DataEntryOperator")?.map(({ id, name }) => ({
                            value: name,
                            label: `${name}`,
                        }))
                    );
                }

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchCoordinator();
    }, [subcompany]);

    const handlecoordinator = (option) => {
        if (!option) {
            if (value === "id") {
                settoggleCoordinator("null");
            } if (value === "name") {
                settoggleCoordinatorName("");
            }
            return; // Ensure function exits when clearing selection
        }

        if (value === "id") {
            settoggleCoordinator(option.value);
        } if (value === "name") {
            settoggleCoordinatorName(option.value);
        }

    };






    return (
        <>

            <div title="Coordinator Filter" className="field-cont-div">
                <Employee />
                <Select
                    key={toggleCoordinator || toggleCoordinatorName} // Forces re-render
                    className="attendance-input-field  date-field"

                    options={coordinatorList}
                    value={
                        value === "id"
                            ? coordinatorList.find((item) => item.value === toggleCoordinator) || "null"
                            : value === "name"
                                ? coordinatorList2.find((item) => item.value === toggleCoordinatorName) || ""
                                : "null"
                    }
                    onChange={handlecoordinator}
                    isClearable
                    placeholder="Select a Coordinator"
                    styles={CSSForFilterDropdown}
                />

                <hr className="field-cont-hr" />
            </div>
        </>
    );
};





export { LetterStatus, LetterType, MonthOptions, YearOptions, StatusFilter, LetterNumberFilter, YearModern, Monthprefix0, MonthModern, SubCompany, ContractorModern, SubCompanyModern, VehicleModern, Projects, ContractorFilter, DesignationModern, DivisionModern, AEFilter, EmployeeFilter, CoordinatorFilter }